import {
  call, put, select, takeLatest,
} from 'redux-saga/effects';
import _ from 'lodash';
import {
  getBasketContentResponse,
  getBasketContentRequest,
  getDiningOptionsSuccess,
  getSpecialServicesResponse,
  setCruiseItineraryDiningOptions,
} from '../../slices/trip';
import axios from '../axiosConfig';

const queryString = require('query-string');

function* getBasketContentWorkers({ payload: { tripId } }) {
  try {
    const trip = yield select((store) => store.trip.selectedTrips[tripId]);
    const { cabins } = trip.cruiseItinerary;
    const { selectedShipCabinCategory } = cabins[0];
    const { sessionKey } = selectedShipCabinCategory || {};

    const url = `/cruises/GetBasketContents?${queryString.stringify(
      {
        sessionKey,
      },
      { skipNull: true },
    )}`;
    const config = {
      method: 'get',
      url,
    };
    const { data } = yield call(axios, config);
    if (data) {
      yield put(getBasketContentResponse({ tripId }));
      if (data.diningOptions && data.diningOptions.length) {
        yield put(
          getDiningOptionsSuccess({
            tripId,
            diningOptions: data.diningOptions,
          }),
        );
        yield put(setCruiseItineraryDiningOptions({
          tripId,
          diningOptionsForRooms: _.map(data.diningOptions, (diningOption) => ({
            roomIndex: diningOption.roomIndex,
            selectedDiningSeat: (diningOption.diningSeats || [])[0],
            selectedDiningTable: (diningOption.diningTables || [])[0],
          })),
        }));
      }

      if (data.specialServices && data.specialServices.length) {
        yield put(
          getSpecialServicesResponse({
            specialServices: data.specialServices,
            tripId,
          }),
        );
      }
    }
  } catch (error) {
    console.log(error);
    yield put(
      getBasketContentResponse({
        tripId,
        error: `${error.response.data.title} ${error.response.data.detail}`,
      }),
    );
  }
}

function* getBasketContentWatcher() {
  yield takeLatest(getBasketContentRequest.toString(), getBasketContentWorkers);
}
export default getBasketContentWatcher;
